module.exports = __webpack_public_path__ + "img/off.350275f5.png";